import { useMemo } from 'react'

import { useStepAccountsConnections } from './use-step-accounts-connections.hook'
import { IStepFormSelectedAccount } from 'src/types'

interface IProps {
  selectedAccount: IStepFormSelectedAccount | null
  setSelectedAccount: (v: IStepFormSelectedAccount | null) => void
  handleRemoveConfirmation: () => void
}

const useStepAccountsConnectionsSelection = ({
  setSelectedAccount,
  selectedAccount,
  handleRemoveConfirmation,
}: IProps) => {
  const { data: items } = useStepAccountsConnections()

  const selectedAccountsConnections = useMemo(() => {
    if (!items?.length || !selectedAccount) return []

    const item = items.find((item) => item.id === selectedAccount.id)
    return item ? [item] : []
  }, [selectedAccount, items])

  const handleSelectedAccount = (id: string) => {
    if (selectedAccount?.id !== id) {
      setSelectedAccount({ id, landing_page_show: false })
      return
    }

    handleRemoveConfirmation()
  }

  const handleSelectedAccountShow = () => {
    setSelectedAccount(
      selectedAccount
        ? { ...selectedAccount, landing_page_show: !selectedAccount.landing_page_show }
        : null,
    )
  }

  return { selectedAccountsConnections, handleSelectedAccount, handleSelectedAccountShow }
}

export { useStepAccountsConnectionsSelection }
